import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'
import { isLegacyPlan, isSeriesPlan } from '../lib/plans'

interface PlanAccessRouteProps {
  children: React.ReactNode
  hideFor: 'legacy' | 'series' | 'non-legacy'
}

const PlanAccessRoute: React.FC<PlanAccessRouteProps> = ({ children, hideFor }) => {
  const { user } = useAuth()
  const plan = user?.plan

  if (hideFor === 'legacy' && isLegacyPlan(plan)) {
    return <Navigate to="/" replace />
  }

  if (hideFor === 'series' && isSeriesPlan(plan)) {
    return <Navigate to="/" replace />
  }

  if (hideFor === 'non-legacy' && !isLegacyPlan(plan)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default PlanAccessRoute